module.exports = __webpack_public_path__ + "img/shuttle-van.7fb08ade.svg";